const AddToPlan = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={10} height={6} {...props}>
    <path d='M1.5 1h7M1.5 5H6' />
  </svg>
);
export default AddToPlan;
